/**
 * 登录页表单交互逻辑（Phase 1 从 main-login.liquid 抽出）
 *
 * 职责：邮箱校验、Continue 跳转、第三方登录 UI、layoutChange 重新初始化
 * 由 sections/main-login.liquid 通过 root-layout page_js 在 DOM 之后加载
 */

// function getCheckoutUrlFromSession() {
//   return `/pages/check`;
// }

// 将现有的初始化代码包装成函数
  function initializeLoginPage() {
    // 根据当前设备类型选择正确的布局
    const isMobile = window.innerWidth <= 734;
    const targetLayout = isMobile ? '.root-mobile-layout' : '.root-desktop-layout';

    // 在指定的布局中查找元素
    const layout = document.querySelector(targetLayout);
    if (!layout) {
      return;
    }

    const form = layout.querySelector('#loginForm');
    const emailInput = layout.querySelector('.login-page__email-input input');
    const continueButton = layout.querySelector('.login-page__continue-button');
    const googleLoginBtn = layout.querySelector('.google-button');
    const appleLoginBtn = layout.querySelector('.apple-button');

    // 从sessionStorage恢复邮箱
    function restoreEmailFromSession() {
      const savedEmail = sessionStorage.getItem('loginEmail');
      if (savedEmail && emailInput) {
        emailInput.value = savedEmail;
      }
    }

    // 显示错误信息
    function showError(message, type = 'backend') {
      window.showTextInputError(message, 'input[data-intended-type="email"]');
    }

    // 隐藏错误信息
    function hideError() {
      window.hideTextInputError('input[data-intended-type="email"]');
    }

    // 调用邮箱验证接口
    async function callBackendAPI(email) {
      // 登录页面调用时传入type=1（注册类型）
      const result = await window.userProfileAPI.checkEmailValidity(email, 1);
      
      // 直接返回结果，不使用 throw
      return result;
    }

    // Google 登录处理
    async function handleGoogleLogin() {
      try {
        // 调用 Google OAuth 登录
        oauthSignIn();
      } catch (error) {
        console.error('Google login failed:', error);
      }
    }

    // Apple 登录处理
    async function handleAppleLogin() {
      try {
        // 检查 Apple ID SDK 是否加载
        if (typeof window.AppleID === 'undefined') {
          await loadAppleIDSDK();
        }

        // 初始化Apple ID（如果还未初始化）
        if (window.AppleID && window.AppleID.auth) {
          try {
            AppleID.auth.init({
              clientId: 'strutt.inc',
              scope: 'name email',
              redirectURI: 'https://co-designer.strutt.inc/pages/login',
              usePopup: false
            });

            // 开始登录
            window.AppleID.auth.signIn();
          } catch (initError) {
            console.error('Apple ID初始化失败:', initError);
            if (window.showToast) {
              window.showToast('Apple Sign In initialization failed. Please try again.', 'error', 5000);
            }
          }
        } else {
          console.error('Apple ID SDK still not available after retry');
          alert('Apple Sign In is not available at the moment. Please try again later.');
        }

      } catch (error) {
        console.error('Apple login failed:', error);
        if (window.showToast) {
          window.showToast('Apple Sign In failed. Please try again.', 'error', 5000);
        }
      }
    }

    // 加载 Apple ID SDK
    async function loadAppleIDSDK() {
      return new Promise((resolve, reject) => {
        if (typeof window.AppleID !== 'undefined') {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
        script.onload = () => {
          // 等待一小段时间确保SDK完全初始化
          setTimeout(() => {
            resolve();
          }, 100);
        };
        script.onerror = () => {
          console.error('Failed to load Apple ID SDK');
          reject(new Error('Failed to load Apple ID SDK'));
        };
        document.head.appendChild(script);
      });
    }

    // 输入框事件监听
    if (emailInput) {
      // 移除之前的事件监听器（如果存在）
      emailInput.removeEventListener('input', emailInput._inputHandler);
      emailInput.removeEventListener('focus', emailInput._focusHandler);
      emailInput.removeEventListener('blur', emailInput._blurHandler);

      // 创建新的事件处理函数
      emailInput._inputHandler = function () {
        // 清除错误信息（用户输入时）
        hideError();

        // 检查输入框状态来控制按钮
        updateButtonBasedOnInputValidation();
      };

      emailInput._focusHandler = function () {
        hideError();
        if (!this.value.trim()) {
          this.classList.add('component-text-input__field--focused');
        }
      };

      emailInput._blurHandler = function () {
        // 检查输入框状态来控制按钮
        updateButtonBasedOnInputValidation();
      };

      // 添加新的事件监听器
      emailInput.addEventListener('input', emailInput._inputHandler);
      emailInput.addEventListener('focus', emailInput._focusHandler);
      emailInput.addEventListener('blur', emailInput._blurHandler);
    }

    // 根据输入框状态更新按钮 - 只要有值就可以点击
    function updateButtonBasedOnInputValidation() {
      if (!emailInput || !continueButton) return;

      const value = emailInput.value.trim();

      // 只要有值就可以启用按钮
      if (value) {
        continueButton.classList.remove('component-cta-button--disabled');
        continueButton.classList.add('component-cta-button--enabled');
        continueButton.disabled = false;
      } else {
        // 如果为空，禁用按钮
        continueButton.classList.remove('component-cta-button--enabled');
        continueButton.classList.add('component-cta-button--disabled');
        continueButton.disabled = true;
      }
    }

    // 初始化按钮状态 - 默认禁用
    if (continueButton) {
      continueButton.classList.remove('component-cta-button--enabled');
      continueButton.classList.add('component-cta-button--disabled');
      continueButton.disabled = true;
    }

    // 表单提交事件
    if (form) {
      // 移除之前的事件监听器（如果存在）
      form.removeEventListener('submit', form._submitHandler);

      // 创建新的事件处理函数
      form._submitHandler = async function (e) {
        e.preventDefault();

        // 检查输入框是否有错误状态（包括 XSS 错误）- 如果有错误状态，阻止提交
        if (emailInput && emailInput.classList.contains('component-text-input__field--error')) {
          // 输入框处于错误状态（可能是 XSS 或其他验证错误），阻止提交
          return;
        }

        // 使用输入框组件的验证状态
        const value = emailInput.value.trim();

        if (!value) {
          // 输入框组件已经处理了验证状态，这里不需要额外处理
          return;
        }

        // 隐藏之前的错误信息
        hideError();

        try {
          // 调用邮箱验证接口
          const backendResult = await callBackendAPI(value);
          
          const accountResult = window.resolveAccountCheck
            ? window.resolveAccountCheck('login', backendResult)
            : { allow: false, blocked: true, needActivate: false, message: backendResult?.message || 'Please try again.' };
          if (accountResult.blocked) {
            showError(accountResult.message, 'backend');
            updateButtonBasedOnInputValidation();
            return;
          }

          // 账号存在但未激活
          if (accountResult.needActivate) {
            // 存储验证所需信息到 sessionStorage，具体发送逻辑由验证码页面处理
            sessionStorage.setItem('verifyEmail', value);
            sessionStorage.setItem('verificationType', 'activate'); // 标记为激活场景
            sessionStorage.setItem('mailScene', '7'); // 存储场景值
            window.location.href = window.withSitePrefix ? window.withSitePrefix('/pages/activate') : '/pages/activate';
            // window.location.href = window.withSitePrefix ? window.withSitePrefix('/pages/verify-code') : '/pages/verify-code';
            return;
          }

          // 检查结果（使用新的格式）
          if (backendResult.code !== 200) {
            console.error('Backend API failed:', backendResult.message);
            
            // 显示错误信息
            showError(backendResult.message || 'Please try again', 'backend');
            
            // 更新按钮状态，确保有值时按钮可以点击
            updateButtonBasedOnInputValidation();
            return;
          }

          // 邮箱验证通过，存储到sessionStorage并跳转到密码输入页面

          // 存储邮箱到sessionStorage
          sessionStorage.setItem('loginEmail', value);

          // 根据设备类型跳转到不同页面
          setTimeout(() => {
            window.location.href = window.withSitePrefix ? window.withSitePrefix('/pages/login-password') : '/pages/login-password';
          }, 500);
        } catch (error) {
          // 捕获所有可能的异常（网络错误、超时、JSON解析错误等）
          console.error('API call error:', error);
          
          // 显示友好的错误信息
          showError('Network error, please try again.', 'backend');
          
          // 恢复按钮状态，允许用户再次尝试
          updateButtonBasedOnInputValidation();
        }
      };

      // 添加新的事件监听器
      form.addEventListener('submit', form._submitHandler);
    }

    // Google 登录按钮事件
    if (googleLoginBtn) {
      // 移除之前的事件监听器（如果存在）
      googleLoginBtn.removeEventListener('click', googleLoginBtn._clickHandler);

      // 创建新的事件处理函数
      googleLoginBtn._clickHandler = handleGoogleLogin;

      // 添加新的事件监听器
      googleLoginBtn.addEventListener('click', googleLoginBtn._clickHandler);
    }

    // Apple 登录按钮事件
    if (appleLoginBtn) {
      // 移除之前的事件监听器（如果存在）
      appleLoginBtn.removeEventListener('click', appleLoginBtn._clickHandler);

      // 创建新的事件处理函数
      appleLoginBtn._clickHandler = handleAppleLogin;

      // 添加新的事件监听器
      appleLoginBtn.addEventListener('click', appleLoginBtn._clickHandler);
    }

    // Sign Up 按钮点击事件
    const registerButton = layout.querySelector('.login-page__register-button');
    if (registerButton) {
      registerButton.addEventListener('click', function() {
        const registerUrl = window.withSitePrefix ? window.withSitePrefix('/pages/main-register-landing') : '/pages/main-register-landing';
        window.location.href = registerUrl;
      });
    }

    // 从sessionStorage恢复邮箱（页面加载时和布局切换时）
    restoreEmailFromSession();
    
    // 如果恢复了邮箱，更新按钮状态
    if (emailInput && emailInput.value.trim()) {
      updateButtonBasedOnInputValidation();
    }

  }

  // 页面加载时初始化
  document.addEventListener('DOMContentLoaded', function () {
    // 检查是否有来自其他页面的错误提示（如 session expired）
    try {
      const loginToastMessage = sessionStorage.getItem('loginToastMessage');
      if (loginToastMessage) {
        // 清除存储的消息，防止刷新后再次显示
        sessionStorage.removeItem('loginToastMessage');
        // 稍微延迟显示，确保组件已加载
        setTimeout(() => {
          if (window.showToast) {
            window.showToast(loginToastMessage, 'error', 5000);
          }
        }, 300);
      }
    } catch (e) {
      console.warn('Failed to check login toast message:', e);
    }

    // 初始加载时初始化
    initializeLoginPage();

    // 第三方登录初始化
    initializeThirdPartyLogin();

    // 布局变化监听器 - 确保在DOM加载后绑定，更安全
    window.addEventListener('layoutChange', function (event) {
      const { newLayout, oldLayout } = event.detail;

      // 重新初始化页面
      initializeLoginPage();
    });
  });

  // 第三方登录初始化函数（保持不变）
  function initializeThirdPartyLogin() {
    // Apple ID 初始化
    if (window.AppleID) {
      try {
        AppleID.auth.init({
          clientId: 'strutt.inc',
          scope: 'name email',
          redirectURI: 'https://co-designer.strutt.inc/pages/login',
          usePopup: false
        });
      } catch (error) {
        console.error('Failed to initialize Apple ID:', error);
      }
    }

    // Apple 登录成功回调 - Popup 模式
    window.addEventListener('AppleIDSignInOnSuccess', async function (event) {

      (async function () {
        try {
          // 从Apple登录事件中获取真实数据
          const appleAuth = event.detail.authorization;
          const user = event.detail.user;

          // 构建真实的Apple认证数据
          const appleAuthData = {
            email: user?.email || '',
            authUserId: user?.user || '',
            firstName: user?.name?.firstName || '',
            lastName: user?.name?.lastName || '',
            emailVerified: true,
            registerSource: 1,
            authPlatform: 2, // 苹果为2
            idToken: appleAuth?.id_token || '',
            code: appleAuth?.code || ''
          };

          // 调用后端登录接口 - 参考Google登录接口
          const baseURL = window.API_BASE_URL;
          const response = await fetch(`${baseURL}/authority/api/third/token`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Client-Type': 'app'
            },
            body: JSON.stringify({
              thirdPlatform: 1, // Apple为1，Google为2
              idToken: appleAuth?.id_token || ''
            })
          });

          if (!response.ok) {
            throw new Error(response.message);
          }

          const loginResp = await response.json();
          if (loginResp && loginResp.code === 200) {
            // 先清除所有旧的 token，确保使用新的 token
            if (window.authAPI && window.authAPI.clearAllTokens) {
              window.authAPI.clearAllTokens();
            }
            
            // 保存 accessToken / refreshToken - 参考Google登录的token保存逻辑
            if (loginResp.data) {
              if (loginResp.data.accessToken) {
                window.authAPI.saveAccessToken(loginResp.data.accessToken);
              }
              if (loginResp.data.refreshToken) {
                window.authAPI.saveRefreshToken(loginResp.data.refreshToken);
              }
              if (window.userProfileAPI && window.userProfileAPI.clearCachedUserData) {
                window.userProfileAPI.clearCachedUserData();
              }
            }

            // 检查是否是注册成功的情况
            if (loginResp.message && loginResp.message.toLowerCase().includes('we created an account for you')) {
              // 注册成功，仅当有 messageCode 时显示成功消息
              if (loginResp.messageCode != null) {
                window.showToast(loginResp.message || 'Operation completed successfully.', 'normal', 3000);
              }
            } else if (loginResp && loginResp.messageCode != null) {
              // 普通登录成功，仅当返回了 messageCode 时显示提示
              window.showToast(loginResp.message || 'Operation completed successfully.', 'normal', 3000);
            }

            // 用户已存在或新注册成功，检查是否从商品详情页来的
            // const fromProductPage = sessionStorage.getItem('fromProductPage');
            // if (fromProductPage === 'true') {
            //   // 从商详来：走限购逻辑
            //   window.location.href = window.withSitePrefix ? window.withSitePrefix('/pages/check') : '/pages/check';
            //   return;
            // }

            // 默认跳转逻辑
            const isMobile = window.innerWidth <= 734;

            // Check for transfer flag
            const transferFlag = sessionStorage.getItem('transferFlag');
            const transferOrderName = sessionStorage.getItem('transferOrderName');
            const transferEmail = sessionStorage.getItem('transferEmail');

            if (transferFlag === 'true' && transferOrderName && transferEmail) {
               window.location.href = `/pages/deposit-transfer?orderName=${encodeURIComponent(transferOrderName)}&email=${encodeURIComponent(transferEmail)}`;
               return;
            }

            if (isMobile) {
              window.location.href = window.withSitePrefix ? window.withSitePrefix('/pages/mobile-menu') : '/pages/mobile-menu';
            } else {
              window.location.href = window.withSitePrefix ? window.withSitePrefix('/pages/my-account') : '/pages/my-account';
            }
            return;
          } else {
            //这里会有这个情况吗?
            // 用户不存在，显示后端返回的message或默认提示
            const errorMessage = loginResp.message || 'This account isn\'t signed up. Please sign up first.';
            window.showToast(errorMessage, 'error', 5000);
          }
        } catch (e) {
          console.error('Apple login failed:', e);
          // 显示错误信息 - 优先显示后端返回的message
          const errorMessage = e.message || 'Login failed, please try again.';
          window.showToast(errorMessage, 'error', 5000);
        }
      })();
    });

    // // Apple 登录失败回调 - Popup 模式（含用户取消）
    // window.addEventListener('AppleIDSignInOnFailure', function (event) {

    //   if (event.detail) {
    //   }
    //   hideLoading();

    //   // 终端取消/失败统一提示
    //   window.showToast('Sign up failed, please try again.', 'error', 5000);
    // });

    // // Google 登录回调处理
    // window.addEventListener('message', function (event) {
    //   if (event.origin === 'https://accounts.google.com') {
    //     if (event.data.type === 'success') {
    //       hideLoading();
          
    //       // 检查是否从商品详情页来的
    //       const fromProductPage = sessionStorage.getItem('fromProductPage');
    //       if (fromProductPage === 'true') {
    //         // 从商详来：直接跳转 checkout
    //         window.location.href = window.withSitePrefix ? window.withSitePrefix(getCheckoutUrlFromSession()) : getCheckoutUrlFromSession();
    //         return;
    //       }
          
    //       // 默认跳转逻辑
    //       const isMobile = window.innerWidth <= 734;
          
    //       // Check for transfer flag
    //       const transferFlag = sessionStorage.getItem('transferFlag');
    //       const transferOrderName = sessionStorage.getItem('transferOrderName');
    //       const transferEmail = sessionStorage.getItem('transferEmail');

    //       if (transferFlag === 'true' && transferOrderName && transferEmail) {
    //           window.location.href = `/pages/deposit-transfer?orderName=${encodeURIComponent(transferOrderName)}&email=${encodeURIComponent(transferEmail)}`;
    //           return;
    //       }

    //       if (isMobile) {
    //         // 手机端跳转到mobile-navigation
    //         window.location.href = window.withSitePrefix ? window.withSitePrefix('/pages/mobile-menu?source=google') : '/pages/mobile-menu?source=google';
    //       } else {
    //         // 平板+电脑端跳转到my-account
    //         window.location.href = window.withSitePrefix ? window.withSitePrefix('/pages/my-account?source=google') : '/pages/my-account?source=google';
    //       }
    //     } else if (event.data.type === 'error' || event.data.type === 'cancel') {
    //       hideLoading();
    //       // 终端取消/失败统一提示
    //       window.showToast('Sign up failed, please try again.', 'error', 5000);
    //     }
    //   }
    // });
  }

  // Google OAuth 登录函数 - 支持 id_token
  function oauthSignIn() {
    var oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';
    var form = document.createElement('form');
    form.setAttribute('method', 'GET');
    form.setAttribute('action', oauth2Endpoint);
    var params = {
      'client_id': '434399780698-6rnau89v7a77ilcgd3s0r67ejh69bs7a.apps.googleusercontent.com',
      'redirect_uri': 'https://co-designer.strutt.inc/pages/login',
      'response_type': 'token id_token',
      'scope': 'openid email profile',
      'state': 'shopify_oauth_google',
      'nonce': generateNonce()
    };
    for (var p in params) {
      var input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', p);
      input.setAttribute('value', params[p]);
      form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
  }

  // 生成随机 nonce 用于 id_token 验证
  function generateNonce() {
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
  }
